module.exports = __webpack_public_path__ + "static/media/icono_pais_registro.e53344d0.svg";